import { PanelBarItemModel } from '../panelbar/panelbar-item-model';

let nextId: number = 0;

const parsePanelBarItems = (data: PanelBarItemModel[]): PanelBarItemModel[] => {
  return data.map((item: PanelBarItemModel) => {
    if (!item.id) {
      item.id = `default-${nextId++}`;
    }

    if (item.children) {
      item.children = parsePanelBarItems(item.children);
    }

    return item;
  });
};

export default {
  parsePanelBarItems,
};
